import { Collection } from '../config/enums'
import { Credit, creditConverter } from '../models/Credit'
import { firebaseDb } from './firebase'

export const fetchUserCredits = async (
  consumerId: string,
  onChange: (credits: Credit | null) => void
) => {
  return firebaseDb
    .collection(Collection.credits)
    .withConverter(creditConverter)
    .doc(consumerId)
    .onSnapshot(snap => {
      const credits = snap.exists ? snap.data()! : null
      onChange(credits)
    })
}

// export const seed = async () => {
//   const allHistory: any[] = []

//   for (let i = 0; i < 100; i++) {
//     const data = {
//       author: 'BigMochi',
//       amount: 100 + i,
//       type: randomInteger(1, 2) === 1 ? HistoryType.add : HistoryType.deduct,
//       date: new Date()
//     }

//     allHistory.push(data)
//   }

//   await firebaseDb
//     .collection(Collection.credits)
//     .doc('7umuTUUoyQbRojZMNNDUyT7EshF2')
//     .update({
//       history: allHistory
//     })
// }

// function randomInteger(min: number, max: number) {
//   return Math.floor(Math.random() * (max - min + 1)) + min
// }
